import { useTranslation } from "react-i18next";
import Image from "next/image";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Domains
import { Topic } from "@/domains/topic";

// Components
import SearchBar from "../filters/SearchBar";
import Topics from "../filters/Topics";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { SectionLayout } from "@/layouts";

// Styles
import * as Styled from "./introBlog.styles";

export const IntroBlog = ({ topics }: { topics: Topic[] }) => {
  const { t } = useTranslation("global");

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Styled.CellectBlogIntroContainer>
      <Image
        src={
          isXs
            ? "/assets/blog/blogPageMobile.webp"
            : "/assets/blog/blogPageLaptop.webp"
        }
        alt="Cellect blog"
        width={1440}
        height={680}
        priority
        style={{
          objectPosition: "center",
          position: "absolute",
          left: 0,
          bottom: 0,
        }} // Use style prop instead
      />

      <SectionLayout>
        <Grid container>
          <Grid
            item
            xs={12}
            md={6}
            lg={6}
            display={"flex"}
            flexDirection={"column"}
            zIndex={3}
          >
            <Styled.CellectBlogIntroCard>
              <Typography
                variant="display-medium"
                fontWeight={500}
                sx={(theme) => ({
                  color: theme.palette.common.corporateColors.primary.white,
                })}
              >
                {t("Blog.heroTitle")}
              </Typography>
              <Typography
                sx={(theme) => ({
                  color: theme.palette.common.corporateColors.primary.white,
                })}
                variant="title-large"
              >
                {t(`Blog.heroSubtitle`)}
              </Typography>

              <SearchBar />

              <Topics list={topics} />
            </Styled.CellectBlogIntroCard>
          </Grid>
        </Grid>
      </SectionLayout>
    </Styled.CellectBlogIntroContainer>
  );
};
